import { render, staticRenderFns } from "./ConsentuaInfo.vue?vue&type=template&id=8b66d3ce&scoped=true&"
import script from "./ConsentuaInfo.vue?vue&type=script&lang=js&"
export * from "./ConsentuaInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConsentuaInfo.vue?vue&type=style&index=0&id=8b66d3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b66d3ce",
  null
  
)

component.options.__file = "ConsentuaInfo.vue"
export default component.exports